<template>
  <div>
      <NxSelect
      :value="localValue"
      :options="listOptions"
      :labelText="label || ''"
      id="selectTag"
      :placeholder="placeholder"
      :multiple="multiple !== undefined ? multiple : false"
      @update:value="handleValueUpdate"
    />
  </div>
</template>
<script>
import TagRepository from '@/shared/http/repositories/configurations/tag.js'
import { toast } from '@/shared/utils/UIHelper'
import { useReactiveModelMixin } from '../../mixins'
import NxSelect from '../selects/NxSelect.vue'

export default {
  name: 'NxSelectTag',
  mixins: [useReactiveModelMixin('value')],
  components: {
    NxSelect
  },
  props: {
    onlyActive: {
      type: Boolean,
      required: false,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Selecione a(s) Tag(s)'
    },
    state: {
      type: Boolean,
      default: null
    },
    excludeTagIds: {
      type: Array,
      required: false,
      default: () => []
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false
    },
    label: {
      type: String,
      required: false,
      default: null
    }
  },
  data () {
    return {
      tagsList: [],
      listOptions: []
    }
  },
  computed: {
    filteredTagsList () {
      // Filtra tags excluídas (já aplicadas ao card)
      if (!this.excludeTagIds || this.excludeTagIds.length === 0) {
        return this.tagsList
      }
      return this.tagsList.filter(tag => !this.excludeTagIds.includes(tag.id))
    }
  },
  watch: {
    filteredTagsList: {
      immediate: true,
      handler (newList) {
        // Atualiza as opções do select quando a lista de tags muda
        this.listOptions = newList.map(tag => ({
          value: tag.id,
          text: tag.nome ? tag.nome.toUpperCase() : ''
        }))
      }
    }
  },
  created () {
    this.onLoadTags()
    // Escuta o evento global de limpar formulário
    this.$root.$on('clearForm', () => {
      this.localValue = null
      this.$emit('update:value', null)
    })
  },
  beforeDestroy () {
    this.$root.$off('clearForm')
  },
  methods: {
    onLoadTags () {
      TagRepository.GetAll()
        .then((res) => {
          let tags = []

          if (res.data && res.data.content) {
            tags = res.data.content
          } else if (Array.isArray(res.data)) {
            tags = res.data
          }

          this.tagsList = tags
        })
        .catch((err) => {
          toast.error('Não foi possível carregar a lista de Tags', 'Erro')
          console.error(err)
        })
    },
    handleValueUpdate (val) {
      // O NxSelect já extrai o value automaticamente, então apenas repassa
      this.localValue = val
    }
  }
}
</script>

<style scoped>
/* Estilos específicos se necessário */
</style>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectTag.vue